class ShopSlider {
  constructor(parent) {
    this.parent = parent;
    if (!this.parent) {
      return;
    }
    this.slider();
  }
  slider = () => {
    let sliders = qsa('.shop-category-slider-js',this.parent);
    if(!sliders){
      return;
    }
    if (window.innerWidth > 767) {
      return false;
    }
    sliders.forEach(element => {
      new Swiper(element, {
        loop: false,
        slidesPerView: 3,
        slidesPerGroup: 1,
        speed: 1000,
        spaceBetween: 30,
        breakpoints: {
          1: {
            slidesPerView: 2.3,
            initialSlide:1,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2,
            initialSlide:1
          },
          1024: {
            slidesPerView: 3,
          },
        },
      });
    }); 
  }
}
new ShopSlider(qs(".shop-categories-inner"));